<template>
  <v-container class="pa-10">
    <v-container>
      <div class="text-h5">Meus testes</div>
      <v-divider />
    </v-container>

    <v-container>
      <v-row no-gutters>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="testList"
            :search="search"
            sort-by="datacriacao"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-col cols="5" class="pa-0">
                  <v-text-field
                    v-model="search"
                    prepend-inner-icon="mdi-magnify"
                    label="Pesquisar"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-spacer></v-spacer>
              </v-toolbar>
            </template>
            <template v-slot:[`item.acao`]="{ item }">
              <v-icon class="mr-2" @click="showItem(item)" v-if="item.status !== 'Concluído'">mdi-play-box</v-icon >
              <v-icon class="mr-2" @click="showItem(item)"  v-if="item.status === 'Concluído'">mdi-eye</v-icon >
              <v-icon class="mr-2" @click="replayItem(item)"  v-if="item.status === 'Concluído'">mdi-replay</v-icon >
              <v-icon class="mr-2" @click="deleteItem(item)" color="red">mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </v-container>
</template>

<script>
  import headers from '../../components/jsonsHelper/headers.json';
  import { mapActions, mapState } from 'vuex';

  export default {
    data: () => ({
      search: '', 
      sortDesc: false
    }),
    created() {
      this.initialize();
    },

    computed: {
      ...mapState('test', ['testList']),
    },

    methods: {
      ...mapActions('test', ['getTestList', 'deleteTest']),
      initialize() {
        this.headers = headers.testeHeaders;
        this.getTestList();
      },
      filterOnlyCapsText(value, search) {
        search = search.toString().toLocaleUpperCase();
        return (
          value != null &&
          search != null &&
          typeof value === 'string' &&
          value
            .toString()
            .toLocaleUpperCase()
            .indexOf(search) !== -1
        );
      },
      deleteItem(item) {
        confirm(
          'Tem certeza que deseja excluir este registro definitivamente? (Esta ação não poderá ser desfeita)',
        ) &&
          this.deleteTest(item.idTeste).then((status) => {
            status === 200 && this.getTestList();
          });
      },

      showItem(item){
        this.$router.push({
        name: "novoTesteModo",
        params: { teste: item.idTeste },
      });
      },
      replayItem(item){
        this.$router.push({
        name: "novoTesteModo",
        params: { teste: item.idTeste },
        query: { refazer: true }
      });
      }
    },
  };
</script>
